import classnames from "classnames";
import dynamic from "next/dynamic";
import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";

import FormErrorText from "@components/UI/Form/FormErrorText";

import { COUNTRY_CODES_CUSTOM } from "@shared/lib/countryCodes";

const ReactPhoneInput = dynamic(import("react-phone-input-2"), {
  ssr: false,
});

interface BookingFormTelephoneProps {
  value: string;
  onChange: (value: string) => void;
  isError: boolean;
  errorType: string;
  name: string;
}

export default function BookingFormTelephone({
  value,
  onChange,
  isError,
  errorType,
  name,
}: BookingFormTelephoneProps) {
  const { defaultCountry } = useSelector((state: AppState) => ({
    defaultCountry:
      state.storage.frontendSettings?.dealerFrontendSettings?.defaultCountry,
  }));

  return (
    <>
      <ReactPhoneInput
        localization={COUNTRY_CODES_CUSTOM}
        value={value}
        country={defaultCountry?.toLowerCase()}
        preferredCountries={[defaultCountry?.toLowerCase()]}
        inputProps={{ name, autoComplete: "nope" }}
        containerClass={classnames(
          "react-tel-input phone-calling-code-wrapper",
          {
            "react-tel-input--filled": value?.length > 11,
            "react-tel-input-error-border": false,
          }
        )}
        inputClass="phone-input-form"
        enableAreaCodes={false}
        onChange={(changeValue, data, event, formattedValue) => {
          const valueWithoutBreaks = formattedValue.split(" ").join("");
          onChange(valueWithoutBreaks);
        }}
        specialLabel={null}
        enableLongNumbers
      />

      {isError && (
        <div className="form-text-input-error">
          <FormErrorText error={errorType} />
        </div>
      )}
    </>
  );
}
